import { Controller } from '@hotwired/stimulus'

import { find } from 'lodash'
import $ from 'jquery';
import 'select2';

export default class extends Controller {
  static targets = [
    'addContainer',
    'appliedContainer',
    'appliedCode',
    'appliedDescription',
    'container',
    'promoOption',
    'promoSelect',
    'selectContainer',
  ];

  initialize() {
    this.fetchHeaders = {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    }
    this.orderId = this.containerTarget.dataset.orderId;
    this.promotionId = this.containerTarget.dataset.orderPromotionId;
    this.checkoutContainer = document.querySelector('#checkout-container')
    this.loadPromoInformation()
  }

  connect() {
    this.$promoSelect = $('#promotion-select');
    this.$promoSelect.select2({ placeholder: 'Promo Code', disabled: !!this.promotionId })
    this.$promoSelect.on('select2:select', event => {
      this.onPromoSelect(event)
    });
    if (this.promotionId) {
      this.$promoSelect.val(this.promotionId)
    }
  }

  loadPromoInformation() {
    this.availablePromotions = this.promoOptionTargets.map(promoTarget => {
      const { id, name, description } = promoTarget.dataset
      return { id: parseInt(id), name, description }
    })
  }

  enablePromoSelect(_event) {
    this.addContainerTarget.classList.add('hidden')
    this.selectContainerTarget.classList.remove('hidden')
  }

  cancelPromoSelect(_event) {
    this.addContainerTarget.classList.remove('hidden')
    this.selectContainerTarget.classList.add('hidden')
  }

  onPromoSelect(_event) {
    if (!this.$promoSelect.val()) {
      return
    }

    const params = { promotion_id: this.$promoSelect.val() }
    fetch(
      `/sandbar/admin/orders/${this.orderId}/promotion`,
      {
        method: 'POST',
        body: JSON.stringify(params),
        headers: this.fetchHeaders,
      }
    )
      .then(resp => {
        if (resp.ok) {
          resp.json().then(order => {
            this.promotionId = order.promotion_id
            const selectedPromotion = find(this.availablePromotions, ['id', order.promotion_id])
            this.$promoSelect.prop('disabled', true)

            this.appliedCodeTarget.innerText = `${selectedPromotion.name}: `
            this.appliedDescriptionTarget.innerText = selectedPromotion.description

            this.addContainerTarget.classList.add('hidden')
            this.selectContainerTarget.classList.add('hidden')
            this.appliedContainerTarget.classList.remove('hidden')

            const promotionChangeEvent = new CustomEvent('promotionChange', { detail: { orderId: order.id } });
            this.checkoutContainer.dispatchEvent(promotionChangeEvent);
          })
        } else {
          resp.json().then(response => console.error(response.message || response));
        }
      })
      .catch(err => console.error(err?.message || err));
  }

  removePromo() {
    fetch(
      `/sandbar/admin/orders/${this.orderId}/promotion`,
      {
        method: 'DELETE',
        headers: this.fetchHeaders,
      }
    )
      .then(resp => {
        if (resp.ok) {
          this.promotionId = null
          this.$promoSelect.val(null).trigger('change')
          this.$promoSelect.prop('disabled', false)

          this.appliedCodeTarget.innerText = ''
          this.appliedDescriptionTarget.innerText = ''

          this.addContainerTarget.classList.remove('hidden')
          this.selectContainerTarget.classList.add('hidden')
          this.appliedContainerTarget.classList.add('hidden')

          const promotionChangeEvent = new CustomEvent('promotionChange', { detail: { orderId: this.orderId } });
          this.checkoutContainer.dispatchEvent(promotionChangeEvent);
        } else {
          resp.json().then(response => console.error(response.message || response));
        }
      })
      .catch(err => console.error(err?.message || err));
  }
}
